import { ImageManagerService } from '../managers/image-manager.service';
import { ToroControllerBundle } from './toro-controller-bundle';

export class EvoControllerBundle extends ToroControllerBundle
{
    constructor(json: any = null, protected imageManager: ImageManagerService)
    {
        super(json, imageManager);

        // if (json)
        // {
        //     // Map the json object to 'this' objects properties.
        //     Object.assign(this, json);
        // }
        //
        // if (json.Controller) this.Controller = new ToroController(json.Controller);
        // if (json.Configuration) this.Configuration = new ToroControllerConfiguration(json.Configuration);
        // if (json.CommCard) this.CommCard = new CommCardDetailed(json.CommCard);

        this.Controller.IsControllerSupported = true;
        this.Controller.RunningModeMaxIntervalDays = 14;
        this.showWaterBudgetForProgram = false;
        this.showClimateLogicSettings = false;
        this.showClimateLogicType = false;
        this.canUpdateNumberOfStations = !this.Controller.IsRecognized;
        this.showGetControllerConfiguration = true;
        this.showResyncCommCard = true;
        this.showImportConfiguration = true;
        this.showExportConfiguration = true;
        this.currentIntervalDayLabel = 'Current Day';

        this.updateDryOutDaysList();
        this.updateFreezeOffTemperatureList();
    }

    public supportedLanguages = [
        { Text: 'English', Value: 0 },
        { Text: 'Portuguese', Value: 5 },
        { Text: 'German', Value: 4 },
        { Text: 'Italian', Value: 3 },
        { Text: 'French', Value: 2 },
        { Text: 'Spanish', Value: 1 }
    ];

    public beginningOfWeekList = [
        { Text: 'Sunday', Value: 0 },
        { Text: 'Monday', Value: 1 }
    ];

    public temperatureScaleList = [
        { Text: '°F', Value: 0 },
        { Text: '°C', Value: 1 }
    ];

    public dateFormats = [
        { Text: 'MM/DD/YY', Value: 0 },
        { Text: 'DD/MM/YY', Value: 1 },
    ];

    public contrastList = this.getContrastList();

    public lengthUnitList = [
        { Text: 'Inches', Value: 0 },
        { Text: 'Meters', Value: 1 },
    ];

    public volumeUnitList = [
        { Text: 'GPM', Value: 0 },
        { Text: 'LPM', Value: 1 }
    ];

    public concurrentStationsList = [
        { Text: '1', Value: 1 },
        { Text: '2', Value: 2 },
        { Text: '3', Value: 3 },
    ];

    getContrastList()
    {
        const list = [];
        for (let i = -15; i <= 15; i++)
        {
            list.push({ Text: this.formatContrastNumber(i), Value: i });
        }
        return list;
    }

    formatContrastNumber(num: number): string
    {
        if (num < 0)
        {
            return num.toString();
        }
        if (num > 0)
        {
            return '+' + num.toString();
        }
        return '0';

    }

    updateDryOutDaysList()
    {
        this.dryOutDaysList = [];
        this.dryOutDaysList.push({ Text: 'Off', Value: 0 });

        for (let i = 1; i <= 14; i++)
        {
            this.dryOutDaysList.push({ Text: i.toString(), Value: i });
        }
    }

    updateFreezeOffTemperatureList()
    {
        this.freezeOffTemperatureList = [];
        this.freezeOffTemperatureList.push({ Text: 'Off', Value: 0 });
        for (let i = 29; i <= 45; i += 2)
        {
            this.freezeOffTemperatureList.push({ Text: i.toString(), Value: i });
        }
    }
}
